'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var MessagesQueue =
/*#__PURE__*/
function () {
  function MessagesQueue() {
    _classCallCheck(this, MessagesQueue);

    this.items = new Map();
    this.iterator = this.items[Symbol.iterator]();
  }

  _createClass(MessagesQueue, [{
    key: "add",
    value: function add(id, item) {
      if (!this.items.has(id)) {
        this.items.set(id, item);
        this.next();
      }
    }
  }, {
    key: "delete",
    value: function _delete(id) {
      this.items.delete(id);
    }
  }, {
    key: "next",
    value: function next() {
      var nextItem = this.iterator.next();

      if (!nextItem.done && typeof nextItem.value[1] === 'function') {
        nextItem.value[1]();
      }
    }
  }]);

  return MessagesQueue;
}();

exports.default = MessagesQueue;